"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var api_1 = __importStar(require("api"));
var use_dialog_1 = require("hooks/use-dialog");
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var UserStore_1 = require("stores/UserStore");
var utils_1 = require("../../../util/utils");
var GanttChart_1 = require("../GanttChart");
var Notification_1 = require("../../Notification");
var GanttChartProjectLink_1 = __importDefault(require("./GanttChartProjectLink"));
var GanttChartProjectHover_1 = __importDefault(require("./GanttChartProjectHover"));
var GanttChartProjectTaskForm_1 = __importDefault(require("./GanttChartProjectTaskForm"));
var GanttChartProjectTask_1 = __importDefault(require("./GanttChartProjectTask"));
var add_icon_svg_1 = __importDefault(require("res/img/add-icon.svg"));
var add_icon_dark_svg_1 = __importDefault(require("res/img/add-icon-dark.svg"));
var Dialog_1 = require("../../Dialog");
var GanttChartProject = function (_a) {
    var highlight = _a.highlight, height = _a.height, currentDate = _a.currentDate, project = _a.project, scrollAmt = _a.scrollAmt, onSetEdit = _a.onSetEdit, setEditId = _a.setEditId, scrollTo = _a.scrollTo;
    var _b = react_1.useState(false), hovering = _b[0], setHovering = _b[1];
    var _c = react_1.useState(null), resizeTaskDown = _c[0], setResizeTaskDown = _c[1];
    var _d = react_1.useState(null), reorderTaskDown = _d[0], setReorderTaskDown = _d[1];
    var _e = react_1.useState(null), addOpen = _e[0], setAddOpen = _e[1];
    var _f = react_1.useState(null), editOpen = _f[0], setEditOpen = _f[1];
    var _g = react_1.useState({}), taskData = _g[0], setTaskData = _g[1];
    var hoverFrameRef = react_1.useRef(null);
    var infoBoxRef = react_1.useRef(null);
    var positionRef = react_1.useRef({ x: 0, y: 0 });
    var _h = use_stores_1.useStores(), projectStore = _h.projectStore, allUserStore = _h.allUserStore, userStore = _h.userStore;
    var saveTimerRef = react_1.useRef(null);
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var _j = react_1.useState(null), tempData = _j[0], setTempData = _j[1];
    var lastXRef = react_1.useRef(null);
    var currentXRef = react_1.useRef(null);
    var taskResizeFrameRef = react_1.useRef(null);
    var taskReorderFrameRef = react_1.useRef(null);
    var taskReorderRef = react_1.useRef(null);
    var projectStart = utils_1.getProjectStart(tempData || project);
    var projectEnd = utils_1.getProjectEnd(tempData || project);
    var _k = userStore.data.settings.generalSettings, zoom = _k.zoom, theme = _k.theme;
    var alwaysShowLabel = userStore.data.settings.ganttChartSettings.alwaysShowLabel;
    react_1.useEffect(function () {
        if (hovering) {
            hoverFrameRef.current = requestAnimationFrame(moveFrame);
            document.addEventListener('mousemove', mouseMoveHandler);
        }
        return function () {
            cancelAnimationFrame(hoverFrameRef.current);
            document.removeEventListener('mousemove', mouseMoveHandler);
        };
    }, [hovering]);
    react_1.useEffect(function () {
        if (resizeTaskDown) {
            taskResizeFrameRef.current = requestAnimationFrame(taskResizeFrame);
            document.addEventListener('mouseup', endTaskResizeHandler);
            document.addEventListener('touchend', endTaskResizeHandler);
        }
        return function () {
            cancelAnimationFrame(taskResizeFrameRef.current);
            document.removeEventListener('mouseup', endTaskResizeHandler);
            document.removeEventListener('touchend', endTaskResizeHandler);
        };
    }, [resizeTaskDown, tempData]);
    react_1.useEffect(function () {
        if (reorderTaskDown) {
            taskReorderFrameRef.current = requestAnimationFrame(reorderTaskFrame);
            document.addEventListener('mouseup', endTaskReorderHandler);
            document.addEventListener('touchend', endTaskReorderHandler);
        }
        return function () {
            cancelAnimationFrame(taskReorderFrameRef.current);
            document.removeEventListener('mouseup', endTaskReorderHandler);
            document.removeEventListener('touchend', endTaskReorderHandler);
        };
    }, [reorderTaskDown, tempData]);
    react_1.useEffect(function () {
        if (addOpen || editOpen)
            document.addEventListener('click', closeTaskForm);
        return function () { return document.removeEventListener('click', closeTaskForm); };
    }, [addOpen, editOpen]);
    var startTaskResizeHandler = function (task, direction) {
        clearTimeout(saveTimerRef.current);
        setResizeTaskDown({ task: task, direction: direction });
        setEditId(project.id);
        document.body.setAttribute('data-resizing', 'true');
        utils_1.lockScroll();
    };
    var endTaskResizeHandler = function () {
        lastXRef.current = null;
        currentXRef.current = null;
        setResizeTaskDown(null);
        document.body.setAttribute('data-resizing', 'false');
        if (tempData)
            saveProject(tempData);
    };
    var taskMoveHandler = function (e) {
        lastXRef.current = currentXRef.current;
        currentXRef.current = utils_1.eventCheck(e) ? e.clientX : e.touches[0].clientX;
    };
    var getGridHover = function (clientX) {
        var gridSpaces = document.querySelectorAll('.gantt-chart-grid__day');
        var targetDate = null;
        for (var i = 0; i < gridSpaces.length; i++) {
            var gridDay = gridSpaces[i];
            var gridDayBounds = gridDay.getBoundingClientRect();
            if (clientX > gridDayBounds.left && clientX < gridDayBounds.right) {
                targetDate = dayjs_1.default(gridDay.getAttribute('data-date'));
                break;
            }
        }
        return targetDate;
    };
    var taskResizeFrame = function () {
        var _a;
        // Cheeky catch for this animation frame being bloody cheeky itself and firing too quickly
        if (document.body.getAttribute('data-resizing') === 'false') {
            cancelAnimationFrame(taskResizeFrameRef.current);
            return;
        }
        if (resizeTaskDown && currentXRef.current) {
            var clientX = currentXRef.current;
            var task_1 = resizeTaskDown.task, direction_1 = resizeTaskDown.direction;
            var whichDate = direction_1 === GanttChart_1.Directions.FORWARDS ? 'endDate' : 'startDate';
            var currentDate_1 = dayjs_1.default(task_1[whichDate]);
            var targetDate = getGridHover(clientX);
            if (!targetDate) {
                taskResizeFrameRef.current = requestAnimationFrame(taskResizeFrame);
                return;
            }
            // Catch outcomes for dragging the endDate too close
            if (direction_1 === GanttChart_1.Directions.FORWARDS) {
                var stopPoint = dayjs_1.default(task_1.startDate);
                if (targetDate.isSame(stopPoint, 'date') || targetDate.isBefore(stopPoint)) {
                    taskResizeFrameRef.current = requestAnimationFrame(taskResizeFrame);
                    return;
                }
            }
            // Catch outcomes for dragging the startDate too close
            if (direction_1 === GanttChart_1.Directions.BACKWARDS) {
                var stopPoint = dayjs_1.default(task_1.endDate);
                if (targetDate.isSame(stopPoint, 'date') || targetDate.isAfter(stopPoint)) {
                    taskResizeFrameRef.current = requestAnimationFrame(taskResizeFrame);
                    return;
                }
            }
            var originalDate_1 = null;
            for (var _i = 0, _b = project.projectTasks; _i < _b.length; _i++) {
                var storeTask = _b[_i];
                if (storeTask.id === task_1.id) {
                    originalDate_1 = dayjs_1.default(storeTask[whichDate]);
                }
            }
            var targetTask_1 = __assign(__assign({}, task_1), (_a = {}, _a[whichDate] = targetDate.format(), _a));
            // Rearrange the array
            if (!targetDate.isSame(currentDate_1, 'date')) {
                var data = tempData || project;
                var dayDiff_1 = originalDate_1.diff(targetDate, 'd');
                var newData = __assign(__assign({}, data), { projectTasks: project.projectTasks.map(function (dataTask) {
                        if (task_1.id === dataTask.id) {
                            return targetTask_1;
                        }
                        var taskStart = dayjs_1.default(dataTask.startDate);
                        var taskEnd = dayjs_1.default(dataTask.endDate);
                        if (direction_1 === GanttChart_1.Directions.BACKWARDS && taskStart.isBefore(originalDate_1)) {
                            return getReturnData();
                        }
                        if (direction_1 === GanttChart_1.Directions.FORWARDS && taskStart.isAfter(originalDate_1)) {
                            return getReturnData();
                        }
                        function getReturnData() {
                            return __assign(__assign({}, dataTask), { startDate: taskStart.subtract(dayDiff_1, 'd').format(), endDate: taskEnd.subtract(dayDiff_1, 'd').format() });
                        }
                        return dataTask;
                    }) });
                setTempData(newData);
                setResizeTaskDown(__assign(__assign({}, resizeTaskDown), { task: targetTask_1 }));
            }
        }
        taskResizeFrameRef.current = requestAnimationFrame(taskResizeFrame);
    };
    var saveProject = function (data) {
        setEditId(project.id);
        api_1.default.editProject(data)
            .then(function (response) {
            projectStore.editDataItem(response.data);
            utils_1.unlockScroll();
            scrollTo(project.id);
            if (tempData)
                setTempData(null);
            if (addOpen)
                setAddOpen(null);
            if (editOpen)
                setEditOpen(null);
            if (Object.keys(taskData).length > 0)
                setTaskData({});
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Project has been saved'
            });
        })
            .catch(api_1.catchHandler);
    };
    var startTaskReorderHandler = function (task) {
        clearTimeout(saveTimerRef.current);
        setReorderTaskDown(task);
        taskReorderRef.current = task;
        document.body.setAttribute('data-reordering', 'true');
        utils_1.lockScroll();
    };
    var endTaskReorderHandler = function () {
        setReorderTaskDown(null);
        taskReorderRef.current = null;
        document.body.setAttribute('data-reordering', 'false');
        if (tempData)
            saveProject(tempData);
    };
    // There must be something weird about this but using a Ref is working nicely for now
    var reorderTaskFrame = function () {
        if (taskReorderRef.current && currentXRef.current) {
            var targetDate = getGridHover(currentXRef.current);
            if (!targetDate || targetDate.isAfter(taskReorderRef.current.startDate) && targetDate.isBefore(taskReorderRef.current.endDate) ||
                targetDate.isSame(taskReorderRef.current.startDate) || targetDate.isSame(taskReorderRef.current.endDate)) {
                taskReorderFrameRef.current = requestAnimationFrame(reorderTaskFrame);
                return;
            }
            var data = tempData || project;
            if (targetDate.isBefore(taskReorderRef.current.startDate)) {
                var prevTask = utils_1.findPreviousTask(taskReorderRef.current, data);
                if (prevTask)
                    moveTask(taskReorderRef.current, prevTask, GanttChart_1.Directions.BACKWARDS);
            }
            if (targetDate.isAfter(taskReorderRef.current.endDate)) {
                var nextTask = utils_1.findNextTask(taskReorderRef.current, data);
                if (nextTask) {
                    moveTask(taskReorderRef.current, nextTask, GanttChart_1.Directions.FORWARDS);
                }
            }
        }
        taskReorderFrameRef.current = requestAnimationFrame(reorderTaskFrame);
    };
    var moveTask = function (task, targetTask, direction) {
        var taskStart = dayjs_1.default(task.startDate);
        var taskEnd = dayjs_1.default(task.endDate);
        var targetTaskStart = dayjs_1.default(targetTask.startDate);
        var targetTaskEnd = dayjs_1.default(targetTask.endDate);
        var taskLength = taskEnd.diff(taskStart, 'd', true);
        var targetTaskLength = targetTaskEnd.diff(targetTaskStart, 'd', true);
        var newTaskEnd = targetTaskStart.add(taskLength, 'd');
        var newTargetTaskEnd = newTaskEnd.add(1, 'd').add(targetTaskLength, 'd');
        if (direction === GanttChart_1.Directions.FORWARDS) {
            newTargetTaskEnd = taskStart.add(targetTaskLength, 'd');
            newTaskEnd = newTargetTaskEnd.add(1, 'd').add(taskLength, 'd');
        }
        var newTask = __assign(__assign({}, task), { startDate: direction === GanttChart_1.Directions.BACKWARDS ?
                targetTask.startDate : newTargetTaskEnd.add(1, 'd').format(), endDate: newTaskEnd.format() });
        var data = tempData || project;
        setTempData(__assign(__assign({}, data), { projectTasks: data.projectTasks.map(function (projectTask) {
                if (projectTask.id === task.id) {
                    return newTask;
                }
                if (projectTask.id === targetTask.id) {
                    return __assign(__assign({}, projectTask), { startDate: direction === GanttChart_1.Directions.BACKWARDS ?
                            newTaskEnd.add(1, 'd').format() : task.startDate, endDate: newTargetTaskEnd.format() });
                }
                return projectTask;
            }) }));
        taskReorderRef.current = newTask;
        setReorderTaskDown(newTask);
    };
    var closeTaskForm = function (e) {
        var target = e.target;
        if (target.closest('.gantt-chart-project-task-form') ||
            target.classList.contains('gantt-chart-project-task-form-task') ||
            target.classList.contains('add-button'))
            return;
        taskFormCloseHandler();
    };
    var deleteTaskHandler = function (task) {
        utils_1.lockScroll();
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Delete task: " + task.taskName + "?",
            description: 'Are you sure you want to delete  this task?',
            catchOnCancel: true
        })
            .then(function () {
            saveProject(utils_1.sortDelete(task, project));
        }, function () {
            setEditId(null);
        });
    };
    var createTasks = function () {
        var widthRef = (window.innerWidth - (80 * zoom)) / 28;
        var range = utils_1.dateRange(currentDate);
        var taskArray = [];
        var data = tempData || project;
        for (var _i = 0, _a = data.projectTasks; _i < _a.length; _i++) {
            var task = _a[_i];
            var taskStart = dayjs_1.default(task.startDate).startOf('d');
            var taskEnd = dayjs_1.default(task.endDate).startOf('d');
            if (taskEnd.isBefore(range.start))
                continue;
            if (taskStart.isAfter(range.end))
                continue;
            var taskLength = taskEnd.diff(taskStart, 'd', true) + 1;
            var leftPos = taskStart.diff(range.start, 'd');
            var style = {
                width: widthRef * taskLength + "px",
                left: widthRef * leftPos + "px"
            };
            taskArray.push(react_1.default.createElement(GanttChartProjectTask_1.default, { key: task.id, task: task, style: style, disableDrag: project.endDate ? GanttChart_1.Directions.FORWARDS : project.startDate ? GanttChart_1.Directions.BACKWARDS : null, onTaskResizeStart: startTaskResizeHandler, onTaskReorderStart: startTaskReorderHandler, resizing: resizeTaskDown && resizeTaskDown.task.id === task.id && resizeTaskDown.direction, reordering: reorderTaskDown && reorderTaskDown.id === task.id, onDelete: deleteTaskHandler, onEdit: editOpenHandler, historic: !project.active }));
        }
        return (react_1.default.createElement("div", { className: 'gantt-chart-project__tasks flex flex-row' }, taskArray));
    };
    var mouseOverHandler = function () {
        if (resizeTaskDown || reorderTaskDown)
            return;
        setHovering(true);
    };
    var mouseLeaveHandler = function () {
        setHovering(false);
    };
    var mouseMoveHandler = function (e) {
        positionRef.current = { x: e.clientX, y: e.clientY };
    };
    var moveFrame = function () {
        if (hovering) {
            var _a = positionRef.current, x = _a.x, y = _a.y;
            if (infoBoxRef.current) {
                if (x > window.innerWidth - infoBoxRef.current.clientWidth)
                    x = x - infoBoxRef.current.clientWidth;
                if (y > window.innerHeight * 0.8)
                    y = y - infoBoxRef.current.clientHeight;
                infoBoxRef.current.style.transform = "translate(" + x + "px, " + (y + scrollAmt) + "px)";
            }
        }
        hoverFrameRef.current = requestAnimationFrame(moveFrame);
    };
    var taskChangeHandler = function (e) {
        var _a;
        setTaskData(__assign(__assign({}, taskData), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var taskTypeChangeHandler = function (taskType) {
        setTaskData(__assign(__assign({}, taskData), { taskType: taskType }));
    };
    var taskUserChangeHandler = function (assignedUserId) {
        var userId = parseInt(assignedUserId);
        var assignedUser = null;
        for (var _i = 0, _a = allUserStore.data; _i < _a.length; _i++) {
            var user = _a[_i];
            if (user.id === userId)
                assignedUser = user;
        }
        setTaskData(__assign(__assign({}, taskData), { assignedUser: assignedUser }));
    };
    var taskSubmitHandler = function (e) {
        e.preventDefault();
        var error = null;
        var taskName = taskData.taskName, taskType = taskData.taskType;
        if (!taskName || taskName.length <= 0) {
            error = 'Please enter a task name';
        }
        if (!taskType || taskType.length <= 0) {
            error = 'Please select a task type';
        }
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        var startDate = addOpen.direction === GanttChart_1.Directions.BACKWARDS ? projectStart.subtract(1, 'w') : projectEnd.add(1, 'd');
        var endDate = addOpen.direction === GanttChart_1.Directions.FORWARDS ? projectEnd.add(1, 'w') : projectStart.subtract(1, 'd');
        if (project.projectTasks.length === 0) {
            startDate = projectStart.startOf('d');
            endDate = projectEnd.startOf('d');
        }
        if (addOpen.direction === GanttChart_1.Directions.BACKWARDS &&
            startDate.isAfter(projectStart.subtract(1, 'w'))) {
            startDate = projectStart.subtract(1, 'w');
        }
        if (addOpen.direction === GanttChart_1.Directions.FORWARDS &&
            startDate.isAfter(projectEnd.add(1, 'd'))) {
            startDate = projectEnd.add(1, 'd');
        }
        var newTask = __assign(__assign({}, taskData), { startDate: startDate.format(), endDate: endDate.format(), assignedUserId: taskData.assignedUser && taskData.assignedUser.id });
        saveProject(utils_1.pinToDeadline(__assign(__assign({}, project), { projectTasks: __spreadArrays(project.projectTasks, [
                newTask
            ]) })));
    };
    var getLinkStyle = function () {
        var widthRef = (window.innerWidth - (80 * zoom)) / 28;
        var range = utils_1.dateRange(currentDate);
        var startPos = projectStart.diff(range.start, 'd');
        var projectLength = projectEnd.diff(projectStart, 'd') + 1;
        var diffToCurrent = currentDate.diff(projectStart, 'd');
        var paddingLeft = '1rem';
        if (alwaysShowLabel && diffToCurrent > 1 && projectEnd.isAfter(currentDate.startOf('w')))
            paddingLeft = ((diffToCurrent - 1) * widthRef) + 16 + "px";
        return {
            width: widthRef * projectLength + "px",
            left: startPos * widthRef + "px",
            paddingLeft: paddingLeft
        };
    };
    var getAddLinkStyle = function (direction) {
        var widthRef = (window.innerWidth - (80 * zoom)) / 28;
        var range = utils_1.dateRange(currentDate);
        var startPos = projectStart.subtract(1, 'd').diff(range.start, 'd');
        var endPos = projectEnd.add(1, 'd').diff(range.start, 'd');
        return {
            width: widthRef + "px",
            left: direction === GanttChart_1.Directions.BACKWARDS ? widthRef * startPos + "px" : widthRef * endPos + "px"
        };
    };
    var createAddLinks = function () {
        var linkArray = [];
        var _loop_1 = function (i) {
            var direction = i === 0 ? GanttChart_1.Directions.BACKWARDS : GanttChart_1.Directions.FORWARDS;
            linkArray.push(react_1.default.createElement("button", { type: 'button', key: "gcp_" + project.id + "_addLink_" + i, style: getAddLinkStyle(direction), "aria-label": 'Add Task', title: 'Add Task', onClick: function (e) { return addOpenHandler(direction, { x: e.clientX, y: e.clientY }); }, className: 'gantt-chart-project__add-task-link' },
                react_1.default.createElement("img", { src: theme === UserStore_1.Themes.DARK ? add_icon_svg_1.default : add_icon_dark_svg_1.default, alt: 'Add' })));
        };
        for (var i = 0; i < 2; i++) {
            _loop_1(i);
        }
        return linkArray;
    };
    var addOpenHandler = function (direction, position) {
        setEditId(project.id);
        setAddOpen({ direction: direction, position: position });
        utils_1.lockScroll();
    };
    var taskFormCloseHandler = function () {
        setAddOpen(null);
        setEditOpen(null);
        setEditId(null);
        setTaskData({});
        utils_1.unlockScroll();
    };
    var editOpenHandler = function (position, task) {
        setEditOpen(position);
        setTaskData(task);
    };
    var taskEditSubmitHandler = function (e) {
        e.preventDefault();
        saveProject(__assign(__assign({}, project), { projectTasks: project.projectTasks.map(function (task) { return task.id === taskData.id ? __assign(__assign({}, taskData), { assignedUserId: taskData.assignedUser && taskData.assignedUser.id }) : task; }) }));
    };
    var getTaskFormStyle = function () {
        return utils_1.openAtPosition(addOpen ? addOpen.position : editOpen, scrollAmt);
    };
    var historic = !project.active;
    return (react_1.default.createElement("div", { className: 'gantt-chart-project flex flex-row', "data-highlight": highlight, "data-historic": historic, onMouseMove: taskMoveHandler, onTouchMoveCapture: taskMoveHandler, "data-hovering": hovering, "data-task-down": resizeTaskDown !== null, style: {
            height: height + "px"
        }, "data-add-open": addOpen !== null || editOpen !== null },
        react_1.default.createElement(GanttChartProjectLink_1.default, { style: getLinkStyle(), project: project, onSetEdit: function (position) { return onSetEdit(project, position); }, historic: historic, onMouseOver: mouseOverHandler, onMouseLeave: mouseLeaveHandler }),
        createTasks(),
        !historic && createAddLinks(),
        hovering &&
            react_1.default.createElement(GanttChartProjectHover_1.default, { infoBoxRef: infoBoxRef, project: project }),
        (addOpen || editOpen) &&
            react_1.default.createElement(GanttChartProjectTaskForm_1.default, { taskData: taskData, users: allUserStore.data, style: getTaskFormStyle(), onChange: taskChangeHandler, onChangeTaskType: taskTypeChangeHandler, onChangeAssignedUser: taskUserChangeHandler, onSubmit: addOpen ? taskSubmitHandler : taskEditSubmitHandler, onClose: taskFormCloseHandler, formType: addOpen ? GanttChart_1.FormTypes.ADD_FORM : GanttChart_1.FormTypes.EDIT_FORM })));
};
exports.default = GanttChartProject;
